import React from 'react';
import { Link } from 'react-router-dom';
import { ComercialLink } from '../comercial360/com360Shared';
import { listUrl } from './emp360Shared';

export const ComerciaisRanking = ({ rows, d, month }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-4 space-y-3" data-testid="emp360-comerciais">
    <h2 className="text-base md:text-lg font-bold font-[Outfit] text-[#2D3E6F]">Quem vende mais este mês</h2>
    {rows.length === 0 ? <div className="text-sm text-slate-400">Sem contratos neste mês.</div> : (
      <div className="divide-y divide-slate-100">
        {rows.map((r, i) => (
          <div key={r.user_id || i} className="flex items-center gap-3 py-2 text-sm" data-testid={`emp360-com-${i}`}>
            <span className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${i === 0 ? 'bg-amber-400 text-white' : i === 1 ? 'bg-slate-300 text-slate-800' : i === 2 ? 'bg-orange-300 text-white' : 'bg-slate-100 text-slate-600'}`}>{i + 1}</span>
            <ComercialLink id={r.user_id} name={r.name} className="flex-1 font-medium truncate" />
            <span className="text-xs text-emerald-700">{r.concluido || 0} concl.</span>
            <span className="text-xs text-slate-500">{r.anulado || 0} anul.</span>
            {r.user_id ? (
              <Link to={listUrl({ category: d.empresa.categoria_principal, company: d.empresa.company, month, proprietario: r.user_id })}
                className="font-bold w-10 text-right hover:underline" title="Ver na listagem">{r.total}</Link>
            ) : <b className="w-10 text-right">{r.total}</b>}
          </div>
        ))}
      </div>
    )}
  </div>
);
